import { Link as RouterLink } from "react-router-dom";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import HomeIcon from "@mui/icons-material/Home";
import { useLang } from "../i18n/LangContext";
import { SEOHead } from "../components/SEOHead";

export function NotFoundPage() {
  const { t } = useLang();
  return (
    <>
      <SEOHead
        title={t("notFoundTitle")}
        description={t("notFoundLead")}
        path="/404"
        noindex
      />
      <main className="page page--text page--center">
        <Typography variant="h3" component="h1" sx={{ fontWeight: 700 }}>
          404
        </Typography>
        <Typography variant="h5" component="p" sx={{ mt: 1, fontWeight: 600 }}>
          {t("notFoundTitle")}
        </Typography>
        <Typography sx={{ mt: 1, color: "text.secondary" }}>{t("notFoundLead")}</Typography>
        <Button
          component={RouterLink}
          to="/"
          variant="contained"
          startIcon={<HomeIcon />}
          sx={{ mt: 3 }}
        >
          {t("notFoundHome")}
        </Button>
      </main>
    </>
  );
}
